 

// import React from 'react';

// const AIMLSolution = () => {
//   return (
//     <div style={styles.container} className="aiml-container">
//       <div style={styles.textSection} className="aiml-text">
//         <h2 style={styles.title}>Why Choose Our AI/ML Solutions?</h2>
//         <p style={styles.description}>
//           Our AI and Machine Learning solutions empower businesses to make smarter decisions, 
//           optimize operations, and unlock new growth opportunities. We combine advanced algorithms 
//           with domain expertise to deliver real-world impact.
//         </p>
//         <p style={styles.description}>
//           From predictive analytics and natural language processing to computer vision 
//           and intelligent automation, we design solutions that are scalable, secure, 
//           and tailored to your unique needs.
//         </p>
//         <p style={styles.description}>
//           We don't just build models—we create end-to-end AI systems that include 
//           data collection, preprocessing, model training, deployment, and ongoing optimization.
//         </p>
//         <p style={styles.description}>
//           With a focus on ethical AI and transparency, our solutions help you stay ahead 
//           of the competition while maintaining trust and compliance.
//         </p>
//       </div>

//       <div style={styles.imageSection} className="aiml-image">
//         <img 
//           src="/image/1686751866426.jpg" 
//           alt="AI/ML Solutions" 
//           style={styles.image} 
          
//         />
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     display: 'flex',
//     flexDirection: 'row',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: 'clamp(20px, 5vw, 60px) clamp(15px, 4vw, 40px)',
//     backgroundColor: 'white',
//     boxSizing: 'border-box',
//     minHeight: '70vh',
//     color: 'black',
//     gap: 'clamp(20px, 4vw, 40px)',
//     flexWrap: 'wrap',
//   },
//   textSection: {
//     flex: '1 1 500px',
//     minWidth: '300px',
//     textAlign: 'left',
//   },
//   title: {
//     fontSize: 'clamp(24px, 4vw, 36px)',
//     fontWeight: 'bold',
//     marginBottom: '20px',
//     color: 'black',
//     lineHeight: '1.3',
//   },
//   description: {
//     fontSize: 'clamp(14px, 1.8vw, 16px)',
//     lineHeight: '1.6',
//     marginBottom: '15px',
//     textAlign: 'left',
//     color: 'black',
//   },
//   imageSection: {
//     flex: '1 1 400px',
//     minWidth: '300px',
//     textAlign: 'center',
//   },
//   image: {
//     width: '100%',
//     height: 'auto',
//     maxWidth: '600px',
//     borderRadius: '8px',
//     boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//     objectFit: 'contain',
//   },
// };

// // Media queries using a style tag for broader compatibility
// const mediaQueries = `
//   @media screen and (max-width: 1024px) {
//     .aiml-container {
//       flex-direction: column;
//       text-align: center;
//     }
//     .aiml-text, .aiml-image {
//       width: 100% !important;
//       text-align: center;
//       padding: 0;
//     }
//     .aiml-text {
//       text-align: center;
//     }
//     .aiml-text p {
//       text-align: center;
//     }
//     .aiml-image img {
//       margin: 0 auto;
//       max-width: 90%;
//     }
//   }

//   @media screen and (max-width: 768px) {
//     .aiml-container {
//       padding: 30px 15px;
//       gap: 25px;
//     }
//     .aiml-text h2 {
//       font-size: 28px !important;
//     }
//   }

//   @media screen and (max-width: 480px) {
//     .aiml-container {
//       padding: 20px 10px;
//       gap: 20px;
//     }
//     .aiml-text h2 {
//       font-size: 22px !important;
//       line-height: 1.3;
//       margin-bottom: 15px;
//     }
//     .aiml-text p {
//       font-size: 14px !important;
//       line-height: 1.5;
//       margin-bottom: 12px;
//       text-align: left;
//     }
//     .aiml-image img {
//       max-width: 100%;
//     }
//   }
// `;

// // Add media queries to document
// if (typeof document !== 'undefined') {
//   const styleSheet = document.createElement('style');
//   styleSheet.textContent = mediaQueries;
//   document.head.appendChild(styleSheet);
// }

// export default AIMLSolution;





import React from "react";
import { motion } from "framer-motion";

const AIMLSolution = () => {
  return (
    <motion.div
      style={styles.container}
      className="aiml-container"
      initial={{ opacity: 0, y: 80 }} // start hidden + shifted down
      whileInView={{ opacity: 1, y: 0 }} // animate when in view
      transition={{ duration: 0.8, ease: "easeOut" }} // smooth animation
      viewport={{ once: true, amount: 0.2 }} // triggers only once
    >
      <motion.div
        style={styles.textSection}
        className="aiml-text"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: "easeOut", delay: 0.2 }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <h2 style={styles.title}>Why Choose Our AI/ML Solutions?</h2>
        <p style={styles.description}>
          Our AI and Machine Learning solutions empower businesses to make smarter decisions, 
          optimize operations, and unlock new growth opportunities. We combine advanced algorithms 
          with domain expertise to deliver real-world impact.
        </p>
        <p style={styles.description}>
          From predictive analytics and natural language processing to computer vision 
          and intelligent automation, we design solutions that are scalable, secure, 
          and tailored to your unique needs.
        </p>
        <p style={styles.description}>
          We don't just build models—we create end-to-end AI systems that include 
          data collection, preprocessing, model training, deployment, and ongoing optimization.
        </p>
        <p style={styles.description}>
          With a focus on ethical AI and transparency, our solutions help you stay ahead 
          of the competition while maintaining trust and compliance.
        </p>
      </motion.div>

      <motion.div
        style={styles.imageSection}
        className="aiml-image"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: "easeOut", delay: 0.4 }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <img
          src="/image/1686751866426.jpg"
          alt="AI/ML Solutions"
          style={styles.image}
        />
      </motion.div>
    </motion.div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "clamp(20px, 5vw, 60px) clamp(15px, 4vw, 40px)",
    backgroundColor: "white",
    boxSizing: "border-box",
    minHeight: "70vh",
    color: "black",
    gap: "clamp(20px, 4vw, 40px)",
    flexWrap: "wrap",
  },
  textSection: {
    flex: "1 1 500px",
    minWidth: "300px",
    textAlign: "left",
  },
  title: {
    fontSize: "clamp(24px, 4vw, 36px)",
    fontWeight: "bold",
    marginBottom: "20px",
    color: "black",
    lineHeight: "1.3",
  },
  description: {
    fontSize: "clamp(14px, 1.8vw, 16px)",
    lineHeight: "1.6",
    marginBottom: "15px",
    textAlign: "left",
    color: "black",
  },
  imageSection: {
    flex: "1 1 400px",
    minWidth: "300px",
    textAlign: "center",
  },
  image: {
    width: "100%",
    height: "auto",
    maxWidth: "600px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    objectFit: "contain",
  },
};

// Media queries remain the same
const mediaQueries = `
  @media screen and (max-width: 1024px) {
    .aiml-container {
      flex-direction: column;
      text-align: center;
    }
    .aiml-text, .aiml-image {
      width: 100% !important;
      text-align: center;
      padding: 0;
    }
    .aiml-text {
      text-align: center;
    }
    .aiml-text p {
      text-align: center;
    }
    .aiml-image img {
      margin: 0 auto;
      max-width: 90%;
    }
  }

  @media screen and (max-width: 768px) {
    .aiml-container {
      padding: 30px 15px;
      gap: 25px;
    }
    .aiml-text h2 {
      font-size: 28px !important;
    }
  }

  @media screen and (max-width: 480px) {
    .aiml-container {
      padding: 20px 10px;
      gap: 20px;
    }
    .aiml-text h2 {
      font-size: 22px !important;
      line-height: 1.3;
      margin-bottom: 15px;
    }
    .aiml-text p {
      font-size: 14px !important;
      line-height: 1.5;
      margin-bottom: 12px;
      text-align: left;
    }
    .aiml-image img {
      max-width: 100%;
    }
  }
`;

if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.textContent = mediaQueries;
  document.head.appendChild(styleSheet);
}

export default AIMLSolution;
